import { render, staticRenderFns } from "./ReapresentacaoTitulo.vue?vue&type=template&id=2ba6b6e8"
import script from "./ReapresentacaoTitulo.vue?vue&type=script&lang=js"
export * from "./ReapresentacaoTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports